{
    "name": "fossilize",
    "author": "Burak Yigit Kaya <ben@byk.im> (https://byk.im)",
    "description": "Create Node SEA binaries across platforms with ease",
    "homepage": "https://github.com/BYK/fossilize",
    "repository": "github:BYK/fossilize",
    "license": "MIT",
    "type": "module",
    "version": "0.10.1",
    "keywords": [
        "node",
        "sea",
        "binary",
        "packaging",
        "packager",
        "fossilize"
    ],
    "files": [
        "dist",
        "import-meta-url.js",
        "entitlements.plist"
    ],
    "main": "dist/index.js",
    "types": "dist/index.d.ts",
    "exports": {
        ".": {
            "types": "./dist/index.d.ts",
            "import": "./dist/index.js"
        }
    },
    "bin": {
        "fossilize": "dist/bin/cli.js",
        "__fossilize_bash_complete": "dist/bin/bash-complete.js"
    },
    "engines": {
        "node": ">=18"
    },
    "scripts": {
        "prebuild": "tsc -p src/tsconfig.json",
        "build": "tsup",
        "prepublishOnly": "npm run build",
        "#postinstall": "npx @stricli/auto-complete@latest install fossilize __fossilize_bash_complete"
    },
    "tsup": {
        "entry": [
            "src/index.ts",
            "src/bin/cli.ts",
            "src/bin/bash-complete.ts"
        ],
        "format": [
            "esm"
        ],
        "tsconfig": "src/tsconfig.json",
        "clean": true,
        "splitting": true,
        "minify": true,
        "sourcemap": true,
        "dts": true
    },
    "dependencies": {
        "@stricli/auto-complete": "^1.1.0",
        "@stricli/core": "^1.1.0",
        "binpunch": "^1.0.0",
        "esbuild": "^0.25.0",
        "macho-unsign": "^2.0.6",
        "p-limit": "^6.2.0",
        "portable-executable-signature": "^2.0.6",
        "postject": "^1.0.0-alpha.6",
        "tar-stream": "^3.1.7",
        "xz-decompress": "^0.2.2",
        "yauzl": "^3.2.0"
    },
    "devDependencies": {
        "@types/node": "22.x",
        "@types/tar-stream": "^3.1.3",
        "@types/yauzl": "^2.10.3",
        "tsup": "^6.7.0",
        "typescript": "5.6.x"
    },
    "volta": {
        "node": "22.14.0"
    }
}
